__turbopack_context__.v({
  "container": "styles-module-scss-module__-NZnxq__container",
  "header": "styles-module-scss-module__-NZnxq__header",
  "post_container": "styles-module-scss-module__-NZnxq__post_container",
  "post_row": "styles-module-scss-module__-NZnxq__post_row",
  "post_text": "styles-module-scss-module__-NZnxq__post_text",
});
